import React from "react";

import { useTranslation } from "react-i18next";

import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { BuildingLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Building_Sanction_Borough_Offices = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {BuildingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass">
                      {t("Address of Borough Offices")}
                    </h3>
                  </div>
                  <div className="mayor-table pump-list-tble">
                    <table
                      width="95%"
                      border={0}
                      align="center"
                      cellPadding={2}
                      cellSpacing={2}
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr
                          bgcolor="#302ba0"
                          tabIndex={0}
                          align="left"
                          valign="middle"
                        >
                          <td
                            width="10%"
                            className="text-white tble-brder-left"
                          >
                            <div align="center">{t("Sl.No")}</div>
                          </td>
                          <td width="20%">
                            <div align="center" className="text-white">
                              {t("Borough")}
                            </div>
                          </td>
                          <td width="58%">
                            <div
                              align="center"
                              className="text-white tble-brder-right"
                            >
                              {t("Address")}
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td width="10%">
                            <div align="center">1.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">I</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              10, B.T. Road, Cossipore.
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td width="10%">
                            <div align="center">2.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">II</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              79, Bidhan Sarani,Hatibagan
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">3.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> III</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              109, Narkeldanga Road, Fulbagan
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">4.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> IV</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              22, Surya Sen Street, College Sqare.
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">5.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> V </div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              22, Surya Sen Street, College Sqare.
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">6.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> VI</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              5, S.N. Banerjee Road, CMO Building
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">7.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> VII</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              5, S.N. Banerjee Road, CMO Building
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">8.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> VIII</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              Crossing of Rashbehari Avenue &amp; Ekdalia near
                              Bijan Setu.
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">9.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> IX </div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              11, Belvedere Road, Alipore.
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">10.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> X</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              C.I.T. Market Complex, Jadavpur
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">11.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> XI</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              B-XI Office at Garia.
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">12.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> XII</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              Santoshpur Market Complex, Santoshpur, Jadavpur.
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">13.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> XIII </div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              D.H. Road, Br. Office, Behala
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">14.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> XIV </div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              D.H. Road, Br. Office, Behala
                            </div>
                          </td>
                        </tr>
                        <tr align="left" valign="middle">
                          <td>
                            <div align="center">15.</div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass"> XV </div>
                          </td>
                          <td align="center">
                            <div className="fontSizeClass">
                              Garden Reach Br. Office
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Building_Sanction_Borough_Offices;
